<!-- <p>time-table-model works!</p>
<app-time-table></app-time-table>
<h1>TESTE</h1>
<app-grid-tile></app-grid-tile> -->

<div>
    <input type="file" (change)="onFileSelected($event)" />
    <button (click)="onUpload()">Enviar</button>
    <button (click)="redirecionar()">Clique para Redirecionar</button>
  </div>

  <!-- <form (ngSubmit)="enviarArquivo()">
    <input type="file" (change)="selecionarArquivo($event)" />
    <button type="submit">Enviar Arquivo</button>
  </form> -->